import i18n from 'i18n'
import dayjs from 'dayjs'
import moment from 'moment'

export const getNowFormatDate = date => {
  return dayjs(date).format(i18n.t('MM月DD日'))
}

export const formatDate = date => {
  let weekday = new Array(7)
  weekday[0] = i18n.t('周日')
  weekday[1] = i18n.t('周一')
  weekday[2] = i18n.t('周二')
  weekday[3] = i18n.t('周三')
  weekday[4] = i18n.t('周四')
  weekday[5] = i18n.t('周五')
  weekday[6] = i18n.t('周六')

  return i18n.t('{slot1}月{slot2}日 {slot3}', {
    slot1: date.getMonth() + 1,
    slot2: date.getDate(),
    slot3: weekday[date.getDay()],
  })
}

export const formatDateYMDHMS = date => {
  // const year = date.getFullYear()
  // const month = String(date.getMonth() + 1).padStart(2, '0')
  // const day = String(date.getDate()).padStart(2, '0')
  // const hours = String(date.getHours()).padStart(2, '0')
  // const minutes = String(date.getMinutes()).padStart(2, '0')
  // const seconds = String(date.getSeconds()).padStart(2, '0')

  // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
}

export const formatDateYMD = date => {
  return dayjs(date).format('YYYY-MM-DD')
}

/**
 * 根据历史预约时间段，分割选中的开始&结束时间。
 * 如下：
 * 选中的时间范围 checkedTimeRange = {startTime: 2020-12-03 13:00:00,endTime: 2020-12-03 20:00:00}
 * 已经存在的数据 existingRanges = [{startTime:2020-12-03 14:00:00, endTime:2020-12-03 16:00:0}]
 * 期望得到结果是 result = [{startTime:2020-12-03 13:00:00,endTime:2020-12-03:14:00:00}, {startTime:2020-12-03 16:00:00, endTime: 2020-12-03 20:00:00}]
 * @param {*} checkedTimeRange
 * @param {*} existingRanges
 * @returns result
 */
export const excludeTimeRanges = (checkedTimeRange, existingRanges) => {
  let result = []
  let currentStart = dayjs(checkedTimeRange.startTime)
  const checkedEnd = dayjs(checkedTimeRange.endTime)

  let hasIntersection = false

  existingRanges.forEach(range => {
    let rangeStart = dayjs(range.startTime)
    let rangeEnd = dayjs(range.endTime)

    if (rangeStart.isAfter(checkedEnd) || rangeEnd.isBefore(currentStart)) {
      return
    }

    hasIntersection = true

    if (rangeStart.isBefore(currentStart)) {
      rangeStart = currentStart
    }
    if (rangeEnd.isAfter(checkedEnd)) {
      rangeEnd = checkedEnd
    }

    if (currentStart.isBefore(rangeStart)) {
      result.push({
        startTime: currentStart.format('YYYY-MM-DD HH:mm:ss'),
        endTime: rangeStart.format('YYYY-MM-DD HH:mm:ss'),
      })
    }
    currentStart = rangeEnd
  })

  if (currentStart.isBefore(checkedEnd)) {
    result.push({
      startTime: currentStart.format('YYYY-MM-DD HH:mm:ss'),
      endTime: checkedEnd.format('YYYY-MM-DD HH:mm:ss'),
    })
  }

  if (!hasIntersection) {
    return [
      {
        startTime: checkedTimeRange.startTime,
        endTime: checkedTimeRange.endTime,
      },
    ]
  }

  return result
}

/**
 * 合并相邻的时间段
 * const list =[
 * {startTime: '2024-07-08 18:00:00',endTime: '2024-07-08 20:00:00'},
 * {startTime: '2024-07-08 20:00:00', endTime: '2024-07-08 21:00:00'},
 * {startTime: '2024-07-08 21:00:00', endTime: '2024-07-08 22:00:00'}
 * ]
 * 期望：{startTime: '2024-07-08 18:00:00',endTime: '2024-07-08 22:00:00'}
 * @param {*} timeRange
 * @returns
 */
export const mergeTimeRanges = timeRange => {
  if (timeRange.length === 0) {
    return []
  }

  // 按 startTime 排序
  timeRange.sort((a, b) => moment(a.startTime).diff(moment(b.startTime)))

  const mergedList = [timeRange[0]]

  for (let i = 1; i < timeRange.length; i++) {
    const lastMerged = mergedList[mergedList.length - 1]
    const current = timeRange[i]

    if (moment(lastMerged.endTime).isSameOrAfter(moment(current.startTime))) {
      // 如果时间段重叠或连续，合并时间段
      lastMerged.endTime = moment
        .max(moment(lastMerged.endTime), moment(current.endTime))
        .format('YYYY-MM-DD HH:mm:ss')
    } else {
      // 如果时间段不连续，直接加入到结果列表
      mergedList.push(current)
    }
  }

  return mergedList
}

export const formatDateOrigin = date => {
  let seperator1 = '-'
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  let currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate
}

/**
 * 通过开始时间和结束时间，得到实际的时间范围
 * @param start
 * @param end
 * @returns
 */
export const getRangesByStartEnd = (start, end, appointmentConfig) => {
  let startT = '00:00',
    endT = '23:59'
  if (appointmentConfig?.mixMakeDay === 'DAY') {
    // 按天，小时和分钟按照该工区所属空间的配置
    const flowDayRuleTimeRange = appointmentConfig?.flowDayRuleTime?.split('-') || []
    startT = flowDayRuleTimeRange?.[0] ?? '00:00'
    endT = flowDayRuleTimeRange?.[1] ?? '23:59'
  }
  return new Array(end.diff(start, 'day') + 1).fill(Object.create(null)).map((_, idx) => {
    const date = start.add(idx, 'day')
    return {
      startTime: `${date.format('YYYY-MM-DD')} ${startT}:00`,
      endTime: `${date.format('YYYY-MM-DD')} ${endT}:59`,
    }
  })
}
